<template>
    <div>
		<van-row class="top-menu">
			<van-col class="top-menu-secelet after-divider" :class="{'item-loading' : wxInvoiceTitleState}" :span="12" @click="getWXInvoiceTitle">
				<div class="top-menu-item">
					<van-loading v-if="wxInvoiceTitleState" color="#1989fa" size="14" />
					<span>获取微信抬头</span>
				</div>
			</van-col>
			<van-col class="top-menu-secelet" :span="12" @click="toInvoiceDetail()">
				<div class="top-menu-item">
					<span>新建开票信息</span>
				</div>
			</van-col>
		</van-row>
		<van-pull-refresh v-model="refreshLoading" @refresh="onRefresh" class="invoice_list-container">
			<van-empty v-if="!invoiceList.length" description="没有开票信息" />
			<van-list
				v-model="listLoading"
				:finished="finished"
				loading-text="..."
				@load="onLoad">
                    <div class="invoice-item-container"
                        v-for="(item, index) in invoiceList"
                        :key="'invoice-item' + index">
                        <van-swipe-cell>
                            <van-cell clickable @click="toInvoiceDetail(item.id)">
                                <van-cell class="invoice-item-card invoice_id" is-link arrow-direction="left">
                                    <template #title>
                                        <div class="invoice-item-headline">
                                            <span class="sub-title">{{invoiceTypes[item.type]}}抬头</span>
                                            <span>{{item.name}}</span>
                                        </div>
                                    </template>
                                </van-cell>
                                <van-cell v-if="item.type === 'company'" class="invoice-item-card" title="纳税人识别号" :value="item.taxpayer_no"/>
                                <van-cell class="invoice-item-card" title="手机号" :value="item.phone"/>
                            </van-cell>

                            <template #right>
                                <van-button square text="删除" type="danger" class="delete-button" @click="del(item.id)" style="height: 100%;" />
                            </template>
                        </van-swipe-cell>
                    </div>
			</van-list>
		</van-pull-refresh>
    </div>
</template>

<script>
    import api from '../../assets/js/api'

    export default {
        name: 'invoiceTitleList',
        data () {
            return {
                refreshLoading: false, //刷新中
				listLoading: false, // 加载中
                invoiceList: [],
				finished: false,
                requestIsLock: false, // 请求锁
				wxInvoiceTitleState: false,
				params: {
                    page: 1,
                    pageSize: 10
                },
            }
        },
        mounted() {
            this.onRefresh()
        },
		computed: {
			invoiceTypes() {
				return this.$store.state.systemEnum.company.user_invoice_info.type
			}
		},
        methods: {
            cardList(id) {
                this.$router.push({
                    name: 'InvoiceCardList',
                    query: {user_invoice_auth_id: id}
                })
            },

            onRefresh () {
                if (this.requestIsLock) return
                // 刷新则初始化页数
                this.finished = false
                this.refreshLoading = true;
                this.params.page = 1
                this.getInvoiceList()
            },

			// 列表滚动加载
            onLoad () {
                if (this.requestIsLock) return
                this.getInvoiceList()
            },			
			
            getInvoiceList () {
                let loading = this.$toast.loading({
                    message: '加载中...',
                    forbidClick: true,
                    loadingType: 'spinner',
                    duration: 0,
                });
                // 关锁
                this.requestIsLock = true;
				const that = this
                api.request('/user_invoice_info/list', {
                    page: this.params.page,
                    page_size: this.params.pageSize,
                }).then(res => {
                    if (that.refreshLoading) {
                        that.invoiceList = []
                        that.refreshLoading = false
                    }
                    // 数据不为空则页数加一，并添加数据至末尾
                    if (!!res.data.data.length) {
                        that.params.page++
                        that.invoiceList = this.invoiceList.concat(res.data.data)
                    }
                    // 判断是否还有数据
                    if (that.invoiceList.length >= res.data.total) {
                        that.finished = true
                    }
					console.log(that.refreshLoading, that.invoiceList)
                }).finally(() => {
					that.listLoading = false
                    that.$toast.clear(loading);
                    // 开锁
                    that.requestIsLock = false
                })
            },

            // 跳转至开票详情
            toInvoiceDetail (invoiceId) {
                let url =  invoiceId ? `/${this.$route.params.companyId}/invoice/invoice_title_detail?id=${invoiceId}` : `/${this.$route.params.companyId}/invoice/invoice_title_detail/`
                this.$router.push({
                    path: url
                })
            },

			// 同步微信抬头
			getWXInvoiceTitle() {
				const that = this;
				wx.ready(function () { 
					that.wxInvoiceTitleState = true;
					wx.invoke('chooseInvoiceTitle', { "scene":"1" }, function(res) { 
                        if (res.err_msg && (res.err_msg.indexOf(':ok') > 0 ||　res.err_msg.indexOf(': ok') > 0)) {
                            that.$toast.loading({
                                message: '加载中...',
                                forbidClick: true,
                                loadingType: 'spinner',
                                duration: 0,
                            });
                            const titleInfo = JSON.parse(res.choose_invoice_title_info)
                            const ruleForm = {
                                type: titleInfo.type == '0' ? 'company' : 'personal',
                                name: titleInfo.title || '',
                                phone: '',
                                taxpayer_no: titleInfo.taxNumber || '',
                                business_address: titleInfo.companyAddress || '',
                                business_telephone: titleInfo.telephone || '',
                                bank_of_deposit: titleInfo.bankName || '',
                                bank_account: titleInfo.bankAccount || '',
                                remarks: '',
                            }

                            api.request('/user_invoice_info/save', ruleForm).then(dres => {
                                that.$dialog({message: dres.msg});
                                that.onRefresh();
                            }).catch(err => {
                                that.$dialog({message: err.msg});
                                that.onRefresh();
                            }).finally(() => {
                                that.$toast.clear();
                                that.wxInvoiceTitleState = false;
                            });
                        } else if (res.err_msg && (res.err_msg.indexOf(':cancel') > 0 ||　res.err_msg.indexOf(': cancel') > 0)) {
                            that.wxInvoiceTitleState = false;
                        } else if (res.err_msg && (res.err_msg.indexOf(':fail') > 0 ||　res.err_msg.indexOf(': fail') > 0)) {
                            that.$dialog({message: '微信接口发生错误,请稍后重试'});
                            that.wxInvoiceTitleState = false;
                        } else {
                            that.wxInvoiceTitleState = false;
                        }
					}); 
				});
			},

            del(id) {
                const that = this;
                this.$dialog.confirm({
                    message: '确定删除吗？',
                }).then(() => {
                    this.$toast.loading({
                        message: '加载中...',
                        forbidClick: true,
                        loadingType: 'spinner',
                        duration: 0,
                    });
                    api.request('/user_invoice_info/delete', {
                        id: id
                    }).then(res => {
                        that.$toast(res.msg);
                        that.onRefresh();
                    }).catch(res => {
                        that.$toast.fail(res.msg);
				    }).finally(() => {
                        that.$toast.clear();
                    })
                });
            }
		},
    }
</script>

<style lang="scss" scoped>
	.top-menu {
		background-color: #fff;
		border-bottom: 1px soild #aaa;
		.top-menu-secelet {
			display: flex;
			align-items: center;
			justify-content: center;
			color: #333;

			.top-menu-item {
				display: flex;
				align-items: center;
				justify-content: center;
				width: 100%;
				span {
					text-align: center;
					padding: 10px;
					font-size: 14px;
					display: inline-block;
				}
			}
		}

		.item-loading {
			color: #ccc;
		}

		.after-divider {
			&::after {
				content: '|'
			}
		}
	}

    .invoice_list-container {
        padding: 0 10px;
        .invoice_id {
            font-size: 16px;
            color: #333;
			&::after {
				border-bottom-color: #999;
			}
        }

        .van-pull-refresh {
            overflow: visible;
        }

        .invoice-item-container {
            margin-top: 10px;
            border-radius: 10px;
            background: #ffffff;
            box-shadow: 0 0 5px 0 rgba(0, 0, 0, .05);
            overflow: hidden;

            .invoice-item-headline {
                span {
                    display: block;
                    font-size: 16px;
                    color: #333;
                }

                .sub-title {
                    font-size: 12px;
                    color: #bbb;
                }
            }
        }

        .van-cell {
            padding: 10px 20px;
        }

        .invoice-item-card{
            padding: 0 0 10px;
            margin-bottom: 5px;
            .van-cell__value{
                overflow: visible;
                font-size: 16px;
            }
            &::after {
                left: 0;
                right: 0;
            }

            &:nth-last-child(1) {
                padding: 0;
                margin-bottom: 0;
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/pages/invoice/InvoiceTitleInfo.vue